import { includes } from 'lodash-es';
import fieldMixin from '@maison/mixins/fieldMixin';
import moment from '@phoenix/moment';

export default {
  mixins: [fieldMixin],

  props: {
    disabledWeekDays: {
      type: Array,
      default: () => [],
    },
    enabledExceptionDates: {
      type: Array,
      default: () => [],
    },
    disabledExceptionDates: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      datepicker: null,
    };
  },

  methods: {
    isDisabledDate(date) {
      const enDate = moment(date).locale('en');

      if (this.enabledExceptionDates.length > 0 && !includes(this.enabledExceptionDates, enDate.format('YYYY-MM-DD'))) {
        return true;
      }

      return (
        (this.disabledWeekDays.length !== 0 && includes(this.disabledWeekDays, date.getDay())) ||
        includes(this.disabledExceptionDates, enDate.format('YYYY-MM-DD'))
      );
    },
  },
};
